import app from 'flarum/forum/app';
import LinkButton from 'flarum/common/components/LinkButton';
import DiscussionsSearchItem from 'flarum/forum/components/DiscussionsSearchItem';
import DiscussionsSearchSource from 'flarum/forum/components/DiscussionsSearchSource';

export default class FuzzyDiscussionsSearchSource extends DiscussionsSearchSource {
  search(query) {
    const normalizedQuery = String(query).toLowerCase();

    return app
      .request({
        method: 'GET',
        url:
          app.forum.attribute('apiUrl') +
          '/space-pocket/search?filter[q]=' +
          encodeURIComponent(normalizedQuery) +
          '&page[offset]=0&page[limit]=' +
          this.limit(),
      })
      .then((payload) => {
        this.results.set(normalizedQuery, app.store.pushPayload(payload));
      });
  }

  view(query) {
    const normalizedQuery = String(query).toLowerCase();
    const discussions = this.results.get(normalizedQuery) || [];
    const allResultsUrl = app.route('spacePocketSearch') + '?q=' + encodeURIComponent(query);

    return [
      <li className="Dropdown-header">{app.translator.trans('core.forum.search.discussions_heading')}</li>,
      <li>
        <LinkButton icon="fas fa-search" href={allResultsUrl}>
          {app.translator.trans('core.forum.search.all_discussions_button', { query })}
        </LinkButton>
      </li>,
      ...discussions.map((discussion) => (
        <DiscussionsSearchItem
          query={normalizedQuery}
          discussion={discussion}
          mostRelevantPost={discussion.mostRelevantPost()}
        />
      )),
    ];
  }
}
